var global = globalThis;
var WORKER_ENABLED = !!(global === global.window && global.URL && global.Blob && global.Worker);

class InlineWorker {
  constructor(func, self) {
    var _this = this;

    if (WORKER_ENABLED) {
      var functionBody = func
        .toString()
        .trim()
        .match(/^function\s*\w*\s*\([\w\s,]*\)\s*{([\w\W]*?)}$/)[1];
      var url = global.URL.createObjectURL(new global.Blob([functionBody], {type: 'text/javascript'}));

      return new global.Worker(url);
    }

    this.self = self;

    this.self.postMessage = function (data) {
      setTimeout(function () {
        _this.onmessage({data: data});
      }, 0);
    };

    setTimeout(function () {
      func.call(self);
    }, 0);
  }

  postMessage(data) {
    setTimeout(function () {
      _this.self.onmessage({data: data});
    }, 0);
  }
}

class AvaRecorder {
  constructor(source, cfg, callBackFnSilence) {
    this.init(source, cfg, callBackFnSilence);
  }

  init(source, cfg, callBackFnSilence) {
    var _this = this;

    this.config = {
      bufferLen: 4096,
      numChannels: 2,
      mimeType: 'audio/wav',
    };

    this.recording = false;
    this.callbacks = {
      getBuffer: [],
      exportWAV: [],
    };

    Object.assign(this.config, cfg);
    this.context = source.context;

    this.startTime = null;
    this.recordingTime = 0;
    this.timerInterval = null;

    this.silenceStart = null;
    this.silenceThreshold = 0.01;

    this.callBackFnSilence = callBackFnSilence;
    this.isGetWav = false;
    this.isGetWavSilent = false;

    this.node = (this.context.createScriptProcessor || this.context.createJavaScriptNode).call(
      this.context,
      this.config.bufferLen,
      this.config.numChannels,
      this.config.numChannels,
    );

    this.node.onaudioprocess = function (e) {
      if (!_this.recording) return;
      let isSilent = true;

      var buffer = [];
      for (var channel = 0; channel < _this.config.numChannels; channel++) {
        let inputData = e.inputBuffer.getChannelData(channel);
        buffer.push(inputData);

        // Check for silence
        if (isSilent && inputData.some(sample => Math.abs(sample) > _this.silenceThreshold)) {
          isSilent = false;
        }
      }

      _this.worker.postMessage({
        command: 'record',
        buffer: buffer,
      });

      if (isSilent) {
        if (_this.silenceStart === null) {
          _this.silenceStart = Date.now();
        }

        const silenceDuration = (Date.now() - _this.silenceStart) / 1000;

        if (silenceDuration >= 2 && typeof _this.callBackFnSilence == 'function' && !_this.isGetWav) {
          _this.silenceStart = Date.now();

          _this.exportWAV(blob => _this.callBackFnSilence(blob));
        }
      } else {
        _this.silenceStart = null;
      }
    };

    source.connect(this.node);
    this.node.connect(this.context.destination); //this should not be necessary

    var self = {};

    this.worker = new InlineWorker(function () {
      var recLength = 0,
        recBuffers = [],
        sampleRate = undefined,
        numChannels = undefined;

      this.onmessage = function (e) {
        switch (e.data.command) {
          case 'init':
            init(e.data.config);
            break;
          case 'record':
            record(e.data.buffer);
            break;
          case 'exportWAV':
            exportWAV(e.data.type);
            break;
          case 'getBuffer':
            getBuffer();
            break;
          case 'clear':
            clear();
            break;
        }
      };

      function init(config) {
        sampleRate = config.sampleRate;
        numChannels = config.numChannels;
        initBuffers();
      }

      function record(inputBuffer) {
        for (var channel = 0; channel < numChannels; channel++) {
          recBuffers[channel].push(inputBuffer[channel]);
        }
        recLength += inputBuffer[0].length;
      }

      function exportWAV(type) {
        var buffers = [];
        for (var channel = 0; channel < numChannels; channel++) {
          buffers.push(mergeBuffers(recBuffers[channel], recLength));
        }
        var interleaved = undefined;
        if (numChannels === 2) {
          interleaved = interleave(buffers[0], buffers[1]);
        } else {
          interleaved = buffers[0];
        }
        var dataview = encodeWAV(interleaved);
        var audioBlob = new Blob([dataview], {type: type});

        this.postMessage({command: 'exportWAV', data: audioBlob});

        return audioBlob;
      }

      function getBuffer() {
        var buffers = [];
        for (var channel = 0; channel < numChannels; channel++) {
          buffers.push(mergeBuffers(recBuffers[channel], recLength));
        }
        this.postMessage({command: 'getBuffer', data: buffers});
      }

      function clear() {
        recLength = 0;
        recBuffers = [];
        initBuffers();
      }

      function initBuffers() {
        for (var channel = 0; channel < numChannels; channel++) {
          recBuffers[channel] = [];
        }
      }

      function mergeBuffers(recBuffers, recLength) {
        var result = new Float32Array(recLength);
        var offset = 0;
        for (var i = 0; i < recBuffers.length; i++) {
          result.set(recBuffers[i], offset);
          offset += recBuffers[i].length;
        }
        return result;
      }

      function interleave(inputL, inputR) {
        var length = inputL.length + inputR.length;
        var result = new Float32Array(length);

        var index = 0,
          inputIndex = 0;

        while (index < length) {
          result[index++] = inputL[inputIndex];
          result[index++] = inputR[inputIndex];
          inputIndex++;
        }
        return result;
      }

      function floatTo16BitPCM(output, offset, input) {
        for (var i = 0; i < input.length; i++, offset += 2) {
          var s = Math.max(-1, Math.min(1, input[i]));
          output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
        }
      }

      function writeString(view, offset, string) {
        for (var i = 0; i < string.length; i++) {
          view.setUint8(offset + i, string.charCodeAt(i));
        }
      }

      function encodeWAV(samples) {
        var buffer = new ArrayBuffer(44 + samples.length * 2);
        var view = new DataView(buffer);

        /* RIFF identifier */
        writeString(view, 0, 'RIFF');
        /* RIFF chunk length */
        view.setUint32(4, 36 + samples.length * 2, true);
        /* RIFF type */
        writeString(view, 8, 'WAVE');
        /* format chunk identifier */
        writeString(view, 12, 'fmt ');
        /* format chunk length */
        view.setUint32(16, 16, true);
        /* sample format (raw) */
        view.setUint16(20, 1, true);
        /* channel count */
        view.setUint16(22, numChannels, true);
        /* sample rate */
        view.setUint32(24, sampleRate, true);
        /* byte rate (sample rate * block align) */
        view.setUint32(28, sampleRate * 4, true);
        /* block align (channel count * bytes per sample) */
        view.setUint16(32, numChannels * 2, true);
        /* bits per sample */
        view.setUint16(34, 16, true);
        /* data chunk identifier */
        writeString(view, 36, 'data');
        /* data chunk length */
        view.setUint32(40, samples.length * 2, true);

        floatTo16BitPCM(view, 44, samples);

        return view;
      }
    }, self);

    this.worker.postMessage({
      command: 'init',
      config: {
        sampleRate: this.context.sampleRate,
        numChannels: this.config.numChannels,
      },
    });

    this.worker.onmessage = function (e) {
      var cb = _this.callbacks[e.data.command].pop();
      if (typeof cb == 'function') {
        cb(e.data.data);
      }
    };
  }

  record() {
    this.recording = true;
    this.recordingTime = 0;
    this.recording = true;
    this.startTime = Date.now();

    this.timerInterval = setInterval(() => {
      const elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);

      this.recordingTime = elapsedTime;
    }, 1000);
  }

  stop() {
    this.recording = false;

    clearInterval(this.timerInterval);

    let elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);

    this.recordingTime = elapsedTime;
  }

  clear() {
    this.startTime = null;
    this.recordingTime = 0;
    this.timerInterval = null;

    this.silenceStart = null;
    this.silenceThreshold = 0.01;

    this.callBackFnSilence = null;
    this.isGetWav = false;
    this.isGetWavSilent = false;

    this.worker.postMessage({command: 'clear'});
  }

  getBuffer(cb) {
    if (!cb) throw new Error('Callback not set');
    this.callbacks.getBuffer.push(cb);
    this.worker.postMessage({command: 'getBuffer'});
  }

  exportWAV(cb, mimeType) {
    mimeType = mimeType || this.config.mimeType;
    cb = cb || this.config.callback;
    if (!cb) throw new Error('Callback not set');

    this.callbacks.exportWAV.push(cb);

    this.worker.postMessage({
      command: 'exportWAV',
      type: mimeType,
    });
  }

  forceDownload(blob, filename) {
    var url = (window.URL || window.webkitURL).createObjectURL(blob);
    var link = window.document.createElement('a');
    link.href = url;
    link.download = filename || 'output.wav';
    var click = document.createEvent('Event');
    click.initEvent('click', true, true);
    link.dispatchEvent(click);
  }
}

export default AvaRecorder;
